module.exports = __webpack_public_path__ + "static/media/linkedin.993f378d.svg";